import TableOperations from 'mini-mail-list-table-operations';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { fetchRichContentForRows } from './helpers/fetchRichContentForRows';
import { getConversationOrItemIdFromRow } from 'mini-mail-list-table-operations/lib/utils/getConversationOrItemIdFromRow';
import { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';
import { shouldSkipProcessRow } from './shouldProcessServerPayload';

export default action('appendRowResponse')(
    /**
     *
     * Process FindConversation/FindItem response and append them to the end of the given TableView
     * @param tableView to append results in
     * @param rows to be appended
     * @param totalRowsInViewInResponse - total rows in the table returned from server
     */
    function appendRowResponse(
        tableView: TableView,
        rows: MailListRowDataType[],
        totalRowsInViewInResponse: number
    ) {
        const rowList: MailListRowDataType[] = rows || [];

        for (const row of rowList) {
            // Check if conversation should be skipped
            if (shouldSkipProcessRow(row, tableView)) {
                continue;
            }

            // Append all conversations to end of table
            if (TableOperations.containsRow(tableView, getConversationOrItemIdFromRow(row))) {
                // Move row to new position in table if it already exists. There could be some timing issue
                // where the row was moved down on the server. In this case we want to keep the server's latest order
                TableOperations.updateRow(tableView.itemIds.length - 1, row, tableView);
            } else {
                TableOperations.appendRow(row, tableView);
            }
        }

        // VSO 1285: optimize this number on empty folder
        tableView.totalRowsInView = totalRowsInViewInResponse; // Sketch: does this belong here?

        fetchRichContentForRows(tableView.id);
    }
);
